export const PROFILE_DETAILS_TYPE_WRITER_DELAY = 40;
